import script from "./changeStatusModal.vue?vue&type=script&setup=true&lang=js"
export * from "./changeStatusModal.vue?vue&type=script&setup=true&lang=js"

import "./changeStatusModal.vue?vue&type=style&index=0&id=350a4326&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-350a4326"]])

export default __exports__